import React from 'react';
import { useTranslation } from 'react-i18next';
import {downloadSvg, iVisitaCircles, verifySvg} from "../../constants/data";
import SlideUp from "../../components/ui/SlideUp";
import {vmsMeta} from "../../constants/meta";
import Meta from "../../components/common/Helmet";

const VisitorManagementSoftware = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Meta
        title={vmsMeta.title}
        description={vmsMeta.description}
        canonical={vmsMeta.canonical}
        keywords={vmsMeta.keywords}
        ogTitle={vmsMeta.title}
        ogDescription={vmsMeta.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto px-4 py-12 space-y-16">
        {/* Hero Section */}
        <section className="text-center space-y-4">
          <h1 className="text-2xl ">{t('common.visitorManagementSoftware')}</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <img
                src={require('../../assets/images/products/pages/in-out.png')}
                alt=""
              />
            </div>
            <div className="flex flex-col justify-center items-start space-y-8 ">
              <div className="text-lg font-bold">{t('common.visitorManagementSoftware')}</div>
              <div className="text-muted-foreground">
                {t('common.ivisitaCompleteDescription')}
              </div>
              <div className="font-medium">{t('common.touchLessCheckIn')}</div>
              <a
                target={'_blank'}
                href={require('../../assets/uploads/pdf/visitors-management-system.pdf')}
                className="w-[120px] text-base mt-8 h-10 rounded-lg bg-theme-color text-white text-center flex items-center justify-center"
                dir="auto"
              >
                {downloadSvg}&nbsp;{t('common.download')}
              </a>
            </div>
          </div>
          <div className="text-xl">{t('common.withIvisitaDescription')}</div>
        </section>

        {/* Features Section */}
        <section className="space-y-8 text-center">
          {iVisitaCircles.map((group, groupIndex) => (
            <div key={groupIndex} className={`grid ${group.cols} gap-8`}>
              {group.items.map((feature, i) => (
                <SlideUp key={i} >
                  <div key={i} className="space-y-10">
                    <div className={`w-36 h-36 mx-auto ${feature.bgColor} text-white rounded-full flex items-center justify-center`}>
                      {/* Icon here */}
                      <img
                        src={require(`../../assets/images/icons/${feature.iconName}`)}
                        alt=""
                      />
                    </div>
                    <h3 className="font-bold">{t(`common.${feature.titleTranslateKey}`)}</h3>
                    <p className="text-base text-muted-foreground">{t(`common.${feature.descTranslateKey}`)}</p>
                  </div>
                </SlideUp>
              ))}
            </div>
          ))}
        </section>

        {/* Automation Section */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="">
            <h2 className="text-xl my-3">{t('common.completelyAutomated')}</h2>
            <p className="text-muted-foreground text-xl mt-8">
              {t('common.organizationToday')}
            </p>
            <div className="flex gap-2 my-10 justify-start items-center">
              <img
                className="w-[30px] h-[30px]" src={verifySvg}
                alt=""
              />
              <div className="text-xl">{t('common.whetherYour')}</div>
            </div>
          </div>
          <div className="flex justify-center">
            <div>
              <img
                src={require('../../assets/images/products/pages/settings-wheel.png')}
                alt=""
              />
            </div>
          </div>
        </section>

        {/* Easy Registration Section */}
        <section className="grid md:grid-cols-2 gap-12 items-center">
          <div className="flex justify-center">
            <img
              src={require('../../assets/images/products/pages/screen.png')}
              alt="Tablet Check-in"
              className="w-64"
            />
          </div>
          <div className="space-y-4">
            <h2 className="text-xl ">{t('common.easyRegistration')}</h2>
            <div className="text-muted-foreground text-xl">
              {t('common.youKnowHowTime')}
            </div>
            <div className="flex gap-2 my-10 justify-start items-center">
              <img className="w-[30px] h-[30px]" src={verifySvg} alt=""/>
              <div className="text-xl">
                {t('common.whetherYouNeed')}
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Visitor Arrival Notification Section */}
      <section className="bg-[#08141A] text-white px-6 py-14">
        <h2 className="text-xl text-center my-10">{t('common.visitorArrivalNotification')}</h2>
        <div className="md:w-theme-container w-mobile-container mx-auto">
         <div className="grid grid-cols-1 md:grid-cols-2">
           <div>
             <p className="text-xl text-left text-muted-foreground mb-4">
               {t('common.onArrival')}
             </p>
             <div className="flex gap-2 my-10 justify-start items-start">
               <img className="w-[30px] h-[30px]" src={verifySvg} alt=""/>
               <div className="text-xl">
                 {t('common.whenAVisitor')}
               </div>
             </div>
           </div>
           <SlideUp>
             <div className="flex justify-end items-start">
               <img
                 className="w-52"
                 src={require('../../assets/images/products/pages/sms.png')}
                 alt=""
               />
             </div>
           </SlideUp>
         </div>
        </div>
      </section>

    </div>
  );
};

export default VisitorManagementSoftware;
